<template>
  <Popup
    v-model="popupShow"
    position="bottom"
    radius="5px"
    class="select-organ-tree-popup"
  >
    <div class="popup-bar">
      <div class="cancel" @click="onCancel">取消</div>
      <div class="title flex-center-x">{{ title }}</div>
      <div class="ok" @click="onOk">确定</div>
    </div>
    <div class="content">
      <Search v-model="searchInput" placeholder="搜索" />

      <div class="panel-unit-list" style="overflow-y: auto;overflow-x: hidden">
        <ul v-for="(model, index) in treeData" :key="index">
          <tree-menu
            :key="searchInput.length > 0"
            :depth="searchInput.length > 0 ? 9 : undefined"
            :model="model"
            @item="onSelect"
            :selected="selected"
            :searchText="searchInput"
          ></tree-menu>
        </ul>
        <div v-if="treeData.length == 0" class="no-data">暂无数据</div>
      </div>
    </div>
  </Popup>
</template>

<script>
import { List, Popup, PullRefresh, Search, Sticky } from "vant";
import { downloadImg } from "@/config";

export default {
  components: {
    Popup,
    PullRefresh,
    Search,
    List,
    Sticky,
  },
  props: {
    show: { type: Boolean, default: false },
    treeData: { type: Array, default: [] },
    defaultSelected: { type: Object, default: {} },
    defaultTitle: { type: String, default: "请选择单位" },
  },
  data() {
    return {
      isReFresh: false,
      finished: false,
      searchInput: "",
      loading: false,
      selected: {},
    };
  },
  created() {
    this.selected = this.defaultSelected;
  },
  computed: {
    filterTree() {
      return this.treeData.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0
      );
    },
    title() {
      return (this.selected || {}).name || this.defaultTitle;
    },
    popupShow: {
      get() {
        return this.show;
      },
      set() {
        this.onCancel();
      },
    },
  },
  methods: {
    onSelect(selected) {
      this.selected = selected;
      setTimeout(this.onOk, 120);
    },
    onCancel() {
      this.$emit("cancel");
    },
    onOk() {
      this.$emit("ok", this.selected);
    },
  },
  watch: {
    defaultSelected(defaultSelected) {
      this.selected = defaultSelected;
    },
  },
};
</script>
<style lang="less" scoped>
.select-organ-tree-popup {
  height: calc(100% - 140px);
  & > .content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 50px);
  }
}

.no-data {
  display: flex;
  justify-content: center;
  color: #aaa;
  margin-top: 10px;
  font-size: 16px;
}
.title {
  width: calc(100% - 70px);
  padding: 0 5px;
}
</style>
